module.exports = __webpack_public_path__ + "static/media/clapIcon.e931d0ed.svg";